import styled from 'styled-components';

export const ModalWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    z-index: 1000;
`;

export const Overlay = styled.div`
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
`;

export const Modal = styled.div`
    position: relative;
    max-width: 80vw;
    min-height: 300px;
    background-color: white;
    border: 1px solid black;
    border-radius: 15px;
    z-index: 1001;
    filter: drop-shadow(10px 15px 10px #333);
    overflow: hidden;
`;

export const ModalHeader = styled.div`
    width: 100%;
    text-align: center;
    border-bottom: 1px solid black;
    padding: 10px 0;
    font-weight: bold;
    background-color: #CCC;
`;

export const ModalContent = styled.div`
    padding: 10px 30px;
    h1 { color: #555; font-size: 1.5rem; }
    p { padding-left: 10px; }
`;

export const ModalActions = styled.div`
    text-align: center;
    padding: 10px 0 30px 0;
`;

export const ActionButton = styled.button`
    padding: 10px 30px;
    border-radius: 8px;
    border: 1px solid #333;
    background: linear-gradient(0deg, #555 0%, #999 100%);
    color: white;
    font-weight: bold;
    cursor: pointer;
    &:hover { background: #555; }
`;